import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// --- ASSETS ---
import back from './image/booking/back.png';
import back_m from './image/booking/back_m.png'; // Sử dụng ảnh dọc cho mobile
import Timeline from './timeline_m';

// --- IMPORT SCHEDULES ---
import TaChiNhuSchedule from './TaChiNhu_book';
import LaoThanSchedule from './LaoThan_book';
import NhiuCoSanSchedule from './NhiuCoSan_book';
import PhuSaphinSchedule from './PhuSaPhin_book';
import KyQuanSanSchedule from './KyQuanSan_book';
import TaLienSonSchedule from './TaLienSon_book';
import LungCungSchedule from './LungCung_book';
import PutalengSchedule from './Putaleng_book';
import SamuSchedule from './SaMu_book';

const MOUNTAINS = [
  { id: 'lt', name: 'LÀO THẨN', level: 'Dễ', distance: '16km', cost: 1500000, bus: '500.000đ (Giường nằm)', guider: 2000000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm', type: 'newbie', tag: 'Săn mây Y Tý', component: LaoThanSchedule },
  { id: 'sm', name: 'SAMU', level: 'Dễ', distance: '14km', cost: 1500000, bus: '500.000đ (Giường nằm)', guider: 2600000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm', type: 'newbie', tag: 'Rừng rêu cổ tích', component: SamuSchedule },
  { id: 'lc', name: 'LÙNG CÚNG', level: 'Vừa', distance: '15km', cost: 1800000, bus: '500.000đ (Giường nằm)', guider: 2600000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm', type: 'newbie', tag: 'Thung lũng gió', component: LungCungSchedule },
  { id: 'ncs', name: 'NHÌU CỒ SAN', level: 'Vừa', distance: '18km', cost: 1800000, bus: '500.000đ (Giường nằm)',guider: 2600000, car: '10.500.000 Xe 16 chỗ ',  date: '2 Ngày 2 đêm', type: 'pro', tag: 'Thác Ong Chúa', component: NhiuCoSanSchedule },
  { id: 'tcn', name: 'TÀ CHÌ NHÙ', level: 'Khó', distance: '22km', cost: 1500000, bus: '600.000đ (Limousine)', guider: 2000000, car: '10.500.000 Xe 16 chỗ )', date: '2 Ngày 2 đêm',  type: 'pro', tag: 'Đỉnh hoa tím', component: TaChiNhuSchedule },
  { id: 'tls', name: 'TẢ LIÊN SƠN', level: 'Vừa', distance: '20km', cost: 1800000, bus: '600.000đ (Limousine)', guider: 2600000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm',  type: 'pro', tag: 'Rừng cổ thụ', component: TaLienSonSchedule },
  { id: 'kqs', name: 'KỲ QUAN SAN', level: 'Rất Khó', distance: '34km', cost: 2500000, bus: '600.000đ (Limousine)',guider: 3400000, car: '10.500.000 Xe 16 chỗ ', date: '3 Ngày 3 đêm',  type: 'pro', tag: 'Bình minh mây', component: KyQuanSanSchedule },
  { id: 'psp', name: 'PHU SA PHÌN', level: 'Khó', distance: '25km', cost: 1500000, bus: '700.000đ (Xe riêng)', guider: 2600000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm',  type: 'pro', tag: 'Hoang sơ', component: PhuSaphinSchedule },
  { id: 'ptl', name: 'PUTALENG', level: 'Rất Khó', distance: '36km', cost: 2500000, bus: '700.000đ (Xe riêng)', guider: 3000000, car: '10.500.000 Xe 16 chỗ ', date: '3 Ngày 3 đêm',  type: 'pro', tag: 'Nóc nhà thứ 3', component: PutalengSchedule },
];

export default function QuickTrekMobileOptimized() {
  const { pathname } = useLocation();
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState(MOUNTAINS[0]);
  const [groupSize, setGroupSize] = useState(1);
  const [backgroundImage, setBackgroundImage] = useState(back);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setBackgroundImage(window.innerWidth < 768 ? back_m : back);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [pathname]);

  const filteredMountains = filter === 'all' ? MOUNTAINS : MOUNTAINS.filter(m => m.type === filter);
  const totalTourCost = selected.cost * groupSize;
  const ActiveSchedule = selected.component;

  return (
    <div className="relative min-h-screen font-sans bg-slate-900 antialiased text-white">
      {/* BACKGROUND SANG TRỌNG */}
      <div className="fixed inset-0 z-0 transition-all duration-700" 
           style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px] z-0"></div>
      </div>

      {/* STICKY CTA CHO MOBILE - GIẢI QUYẾT LỖI ẨN NÚT */}
      <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:hidden bg-gradient-to-t from-slate-900 to-transparent">
        <button 
          onClick={() => window.open('https://www.facebook.com/leminhofhaiduong')}
          className="w-full py-5 bg-orange-500 text-white rounded-full font-black uppercase tracking-widest shadow-2xl active:scale-95 transition-all"
        >
          Nhận báo giá ngay
        </button>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-1 py-10 md:py-20">
        
        {/* HEADER: LOGO TRIẾT LÝ */}
        <header className="mb-10 mt-20 text-center">
          <h1 className="text-5xl md:text-8xl font-black mb-4 tracking-tighter uppercase leading-none">
            QUICK <span className="text-sky-400 italic">TREK</span>
          </h1>
          <p className="text-sky-400 italic text-lg md:text-2xl mb-8">"Chuyến đi này, bạn muốn thử thách bản thân ở mức độ nào?"</p>
          
          {/* FILTER: TO RÕ TRÊN MOBILE */}
          <div className="flex flex-col md:flex-row justify-center gap-2 bg-white/10 p-2 rounded-[25px] backdrop-blur-md border border-white/20">
            {['all', 'newbie', 'pro'].map((type) => (
              <button 
                key={type}
                onClick={() => setFilter(type)}
                className={`px-6 py-3 rounded-[20px] font-black text-[11px] uppercase transition-all ${filter === type ? 'bg-white text-slate-900 shadow-xl' : 'text-white/60 hover:bg-white/5'}`}
              >
                {type === 'all' ? 'Tất cả cung đường' : type === 'newbie' ? '🌿 Người mới' : '🔥 Thử thách'}
              </button>
            ))}
          </div>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
          
          {/* SIDEBAR: NÚI - DẠNG NGANG TRÊN MOBILE ĐỂ TIẾT KIỆM KHÔNG GIAN */}
          <div className="lg:col-span-4 flex md:flex-col gap-3 overflow-x-auto pb-4 md:pb-0 lg:sticky lg:top-10 custom-scrollbar scrollbar-hide">
            {filteredMountains.map((m) => (
              <button
                key={m.id}
                onClick={() => setSelected(m)}
                className={`min-w-[200px] md:min-w-full p-5 rounded-[30px] text-left border-2 transition-all duration-300 ${
                  selected.id === m.id ? 'bg-white border-white text-slate-900 shadow-xl scale-105' : 'bg-white/5 border-transparent text-white/100'
                }`}
              >
                <p className="text-[9px]  uppercase tracking-widest opacity-90 font-black">{m.tag}</p>
                <p className="text-lg font-black">{m.name}</p>
              </button>
            ))}
          </div>

          {/* MAIN CONTENT: HIỆN LỊCH TRÌNH NGAY - KHÔNG CẦN CHỜ ĐIỀN SỐ NGƯỜI */}
          <div className="lg:col-span-8 space-y-6">
            <div className="bg-white rounded-[45px] p-6 md:p-12 shadow-2xl text-slate-900">
              
              {/* SPEC CARDS: TO, RÕ, SANG TRỌNG */}
              <div className="grid grid-cols-3 gap-2 mb-10 pb-8 border-b border-slate-100">
                {[
                  { label: 'Độ khó', value: selected.level },
                  { label: 'Chiều dài', value: selected.distance },
                  { label: 'Giá gốc', value: `${selected.cost.toLocaleString()}đ`, color: 'text-sky-600' }
                ].map((item, idx) => (
                  <div key={idx} className="text-center">
                    <p className="text-[9px] font-black text-slate-300 uppercase mb-1">{item.label}</p>
                    <p className={`text-sm md:text-xl font-black ${item.color || 'text-slate-800'}`}>{item.value}</p>
                  </div>
                ))}
              </div>

              {/* TÍNH TOÁN: TRỰC QUAN */}
              <div className="space-y-8 mb-12">
                <div className="flex justify-between items-center">
                  <label className="text-xs font-black uppercase">Nhóm bạn có:</label>
                  <span className="text-2xl font-black text-sky-600">{groupSize} thành viên</span>
                </div>
                <input type="range" min="1" max="25" value={groupSize} onChange={(e) => setGroupSize(e.target.value)} className="w-full h-3 bg-slate-100 rounded-lg appearance-none cursor-pointer accent-sky-600" />
                
                
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-slate-900 p-6 rounded-[30px] text-white">
                    <p className="text-[9px] uppercase opacity-40 font-black mb-1">Dự toán Tour Bản Địa</p>
                    <p className="text-3xl font-black tracking-tighter">{totalTourCost.toLocaleString('vi-VN')} <span className="text-xs">VNĐ</span></p>
                  </div>
                  <div className="bg-sky-600 p-6 rounded-[30px] text-white">
                    <p className="text-[9px] uppercase opacity-80 font-black mb-1">Dự toán Tour HDV</p>
                    <p className="text-3xl font-black tracking-tighter">{(totalTourCost + selected.guider).toLocaleString('vi-VN')} <span className="text-xs">VNĐ</span></p>
                  </div>
                </div>
                <div className="space-y-6">
                  <label className="text-[11px] font-black text-slate-900 uppercase">Thông tin cơ bản:</label>
                  {groupSize <= 8 ? (
                  <div className="p-5 bg-orange-50 rounded-[28px] border border-orange-100 flex items-start gap-3">
                    <span className="text-xl">🚌</span>
                    <div>
                      <p className="text-[10px] font-black text-orange-600 uppercase mb-1 tracking-widest">Xe đưa đón</p>
                      <p className="text-sm font-bold text-slate-700 italic leading-tight">{selected.bus}</p>
                    </div>
                  </div>): (
                  <div className="p-5 bg-orange-50 rounded-[28px] border border-orange-100 flex items-start gap-3">
                    <span className="text-xl">🚌</span>
                    <div>
                      <p className="text-[10px] font-black text-orange-600 uppercase mb-1 tracking-widest">Xe đưa đón</p>
                      <p className="text-sm font-bold text-slate-700 italic leading-tight">{selected.car}</p>
                    </div>
                    <p className="flex-1 py-2.5 border-2 border-white/60 bg-white/40 backdrop-blur-md rounded-[20px] font-extrabold text-[11px] uppercase text-slate-800 text-center shadow-sm">
                      {selected.date.toLocaleString('vi-VN')} VNĐ
                    </p>
                  </div>)}
                </div>
              </div>

              {/* LỊCH TRÌNH: TRÌNH BÀY DẠNG CARD - GIẢM CHỮ, TĂNG TRỰC QUAN */}
              <div className="pt-8 border-t border-slate-100">
                <div className="flex items-center gap-3 mb-8">
                  <span className="w-1.5 h-8 bg-orange-500 rounded-full"></span>
                  <h3 className="text-2xl font-black uppercase tracking-tighter">Hành trình {selected.name}</h3>
                </div>
                
                <div className="bg-slate-50 rounded-[35px] p-1 md:p-1 overflow-hidden">
                  <ActiveSchedule days={2} groupSize={groupSize} />
                </div>

                <h4 className="text-[10px] font-black text-sky-700 uppercase tracking-widest m-2">Thông tin dịch vụ</h4>
                 <Timeline groupSize={groupSize} days={2} />
              </div>

              {/* NÚT DESKTOP */}
              <button 
                onClick={() => window.open('https://www.facebook.com/leminhofhaiduong')}
                className="hidden md:block w-full mt-12 py-6 bg-slate-900 text-white rounded-[25px] font-black uppercase tracking-widest text-sm hover:bg-sky-600 transition-all"
              >
                Nhận tư vấn chi tiết
              </button>
            </div>
            
            <p className="text-center text-white/20 text-[9px] font-black uppercase tracking-[0.5em] pb-24 md:pb-10">
              Keep Going Club — 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}